import { useState, useEffect } from 'react';
import { useIncidents } from '../../../hooks/useIncidents';
import { getNameIncidentsStatus, translate } from '../../../utils/Common';

const StatusIncidentList = ({
    register,
    errors,
    nameShow,
    idShow,
    readOnly,
    sizeInput,
    currentStatusId
}) => {

    const { statusIncidents, getStatus } = useIncidents();
    const [statusListIncidents, setStatusIncidents] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState(null);

    // Mapeo de transiciones válidas según el estado actual
    const statusTransitions = {
        1: [7, 2, 6],  // NUEVO → ASIGNADO, EN ESPERA, CANCELADO
        2: [6, 3, 4],  // EN ESPERA → CANCELADO, EN PROCESO, RESUELTO
        3: [2, 6, 4],  // EN PROCESO → EN ESPERA, CANCELADO, RESUELTO
        4: [3, 6, 2],  // RESUELTO → EN PROCESO, CANCELADO, EN ESPERA
        6: [2, 3, 4],  // CANCELADO → EN ESPERA, EN PROCESO, RESUELTO
        7: [2, 3, 6],  // ASIGNADO → EN ESPERA, EN PROCESO, CANCELADO
    };

    // Filtra los estatus permitidos
    const getFilteredStatuses = () => {
        if (!statusListIncidents || !currentStatusId) return [];
        const allowedIds = statusTransitions[currentStatusId] || [];
        return statusListIncidents.filter(item => allowedIds.includes(item.id));
    };

    useEffect(() => {
        const abortController = new AbortController();

        const fetchStatus = async () => {
            try {
                const response = await getStatus(abortController.signal);
                setStatusIncidents(response);
            } catch (error) {
                console.error('Error loading statuses:', error);
            }
        };

        if (!statusIncidents) fetchStatus();
        else setStatusIncidents(statusIncidents);

        return () => abortController.abort();
    }, [getStatus, statusIncidents]);

    const filteredStatuses = getFilteredStatuses();
    const currentStatus = statusListIncidents?.find(item => item.id === currentStatusId);

    const handleStatusChange = (e) => {
        const value = parseInt(e.target.value);
        setSelectedStatus(value);
    };

    return (
        <>
            {/* SELECT DE ESTATUS */}
            <select
                className={`${sizeInput ?? "h-9 text-sm"} h-11 w-full rounded-lg border border-transparent bg-muted/60 px-3 text-sm text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed font-small`}
                key={currentStatus ? `status-${currentStatus.id}` : "status-loading"}
                defaultValue={currentStatus ? currentStatus.id : ""}
                name="statusIncident"
                onChange={handleStatusChange}
                readOnly={readOnly}
                ref={register({
                    validate: value =>
                        value !== (translate("global.select") || translate("global.noResults")) ||
                        translate("global.chooseValidTypeIncident")
                })}
            >
                {/* Opción actual deshabilitada */}
                {currentStatus ? (
                    <option value={currentStatus.id} className="text-sm" disabled >
                        {getNameIncidentsStatus(currentStatus.id)}
                    </option>
                ) : (
                    <option value="" disabled className="text-sm">
                        {nameShow || translate("global.noPlatform")}
                    </option>
                )}

                {/* Opciones filtradas */}
                {filteredStatuses.length > 0 ? (
                    filteredStatuses.map(item => (
                        <option key={item.id} className="text-sm" value={item.id}>
                            {getNameIncidentsStatus(item.id)}
                        </option>
                    ))
                ) : (
                    <option value="" disabled className="text-sm">
                        {translate("global.noResults")}
                    </option>
                )}
            </select>

            {/* Validación de errores */}
            {errors.statusIncident && (
                <span className="text-destructive">{errors.statusIncident.message}</span>
            )}

            
        </>
    );
};

export default StatusIncidentList;
